// extracted by mini-css-extract-plugin
export var fullHeightState = "_2g-7";
export var headerCell = "_2g-1";
export var loadingStateCell = "_2g-4";
export var rowWrapper = "_2g-3";
export var standaloneTable = "_2g-8";
export var standaloneTableWithBodyFill = "_2g-9";
export var stateCell = "_2g-5";
export var table = "_2g-0";
export var tableBodyFiller = "_2g-6";
export var white = "_2g-2";